<template>
    <div class="com-codics-book-admin-project-body">
        <div class="com-codics-book-admin-project-bar-content">
            <el-cascader class="com-codics-book-admin-project-bar-pick" :options="typeOptions" v-model="memsList"
                :show-all-levels="false" placeholder="请选择产品类型"
                :props="{ value: 'id', label: 'value', children: 'data' }" clearable
                @change="handleMaterialTypeChange2"></el-cascader>
            <el-select class="com-codics-book-admin-project-bar-pick" v-model="nowSort" placeholder="请选择排序类型" clearable
                @change="listProductsFuc">
                <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input class="com-codics-book-admin-project-bar-input" v-model="searchTxt" placeholder="输入关键词进行搜索..."
                clearable @input="searchChange" @change="handleSearchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="listProductsFuc">&#xe86e;
            </MyButton>
            <MyButton id="addProductBtn" style="float: right;" @click.native="jumpToProduct">&#xe632; 新建产品
            </MyButton>
        </div>
        <div class="com-codics-book-admin-project-bar-content com-codics-book-admin-project-bar-content2"
            style="margin-top: 10px;">
            <div class="com-codics-book-admin-project-list"
                :style="{ '--opacity': (searchTxt ? searchData : tableData).length === 0 ? '1' : '0' }">
                <el-image class="com-codics-book-admin-project-bar-empty" @click="addVisible = true;"
                    v-show="(searchTxt ? searchData : tableData).length === 0"
                    :src="'https://cdn.bosscaigou.com/editor/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9%20%282%29.svg'"></el-image>
                <div v-show="(searchTxt ? searchData : tableData).length === 0" @click="addVisible = true;"
                    class="com-codics-book-admin-project-list-tip">还没有创建产品，点此立即创建~</div>
                <div class="com-codics-book-admin-project-list-item"
                    v-for="(item, index) in (searchTxt ? searchData : tableData)" :key="item.id">
                    <div class="com-codics-book-admin-project-list-item-card"
                        :style="{ 'border': item.checked ? '1px solid #9333ea' : '1px solid #E5E5E5', '--opacity': item.checked ? '1' : '0' }">
                        <el-image class="com-codics-book-admin-project-list-item-card-img"
                            :src="item.himg.startsWith('http') ? item.himg : `https://cdn.bosscaigou.com/${item.himg}`"
                            fit="cover"></el-image>
                        <div class="com-codics-book-admin-project-list-item-card-bottom" :key="refreshKey">
                            <span class="com-codics-book-admin-project-list-item-card-bottom-txt"
                                style="padding-left: 10px;">{{ item.name
                                }}</span>
                            <span
                                class="com-codics-book-admin-project-list-item-card-bottom-txt com-codics-book-admin-project-list-item-card-bottom-time">
                                {{ initTime(item.ctime) }}
                            </span>
                        </div>
                        <div class="com-codics-book-admin-project-list-item-card-add iconfont" title="删除"
                            @click.stop="addCartFuc(item, 1)">&#xF11E; 加入购物车
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[15, 30, 45, 60]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <el-badge :value="cartData.length" class="com-codics-hbb-order-admin-shop-car-btn">
            <el-button class="iconfont" type="success" round plain @click="shopDrawer = true;">&#xe7b7;
                我的购物车</el-button>
        </el-badge>
        <el-drawer title="我的购物车" :visible.sync="shopDrawer" :direction="cartDirection" :size="cartSize">
            <div class="com-codics-hbb-order-admin-shop-car-body"
                :style="{ '--showTxt': cartData.length == 0 ? 'block' : 'none' }">
                <div class="com-codics-book-admin-project-list-item" style="width: 100%;"
                    v-for="(item, index) in cartData" :key="item.id">
                    <div class="com-codics-book-admin-project-list-item-card"
                        :style="{ 'border': item.checked ? '1px solid #9333ea' : '1px solid #E5E5E5', '--opacity': item.checked ? '1' : '0' }">
                        <el-image class="com-codics-book-admin-project-list-item-card-img"
                            :src="item.product.himg.startsWith('http') ? item.product.himg : `https://cdn.bosscaigou.com/${item.product.himg}`"
                            fit="cover"></el-image>
                        <div class="com-codics-book-admin-project-list-item-card-bottom" :key="refreshKey">
                            <span class="com-codics-book-admin-project-list-item-card-bottom-txt"
                                style="padding-left: 10px;">{{ item.product.name
                                }}</span>
                            <el-input-number @change="(value) => addCartFuc(item, value - item.count2)"
                                style="float: right;top: 50%;transform: translateY(-50%);right: 10px;"
                                v-model="item.count" :min="0" :max="10" label="描述文字" size="mini"></el-input-number>
                        </div>
                        <div class="com-codics-book-admin-project-list-item-card-add iconfont" title="删除"
                            @click.stop="addCartFuc(item, 1)">&#xF11E; 加入购物车
                        </div>
                    </div>
                </div>
                <img v-show="cartData.length == 0" class="com-codics-hbb-order-admin-shop-car-empty" title="购物车是空的"
                    src="https://cdn.bosscaigou.com/huayuan/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9.svg">
            </div>
            <div class="com-codics-hbb-order-mess-control"
                :style="{ width: cartDirection == 'btt' ? '100%' : '450px' }">
                <MyButton size="small" type="danger" @click.native="khVisible = true; shopDrawer = false;"
                    style="position: relative;float: right;top: 50%;transform: translateY(-50%);margin-right: 10px;font-size: 11px;"
                    title="生成订单，生成后购物车将清空！">
                    &#xe761; 生成订单
                </MyButton>
                <el-popconfirm style="float: right;position: relative;top: 50%;" confirm-button-text='好的'
                    cancel-button-text='不用了' icon="el-icon-info" icon-color="red" @confirm="clearCart2Fuc"
                    title="确定清空购物车吗？">
                    <MyButton size="small" slot="reference"
                        style="float: right;top: 50%;transform: translateY(-50%);margin-right: 10px;padding:0 10px;"
                        title="清空购物车">
                        &#xe703;
                    </MyButton>
                </el-popconfirm>
            </div>
        </el-drawer>
        <MyDialog :visible.sync="khVisible" title="客户下单" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="绑定客户" required>
                    <el-select style="width:100%;" size="small" v-model="nowSid" clearable filterable remote
                        reserve-keyword placeholder="请选择客户" :remote-method="queryCustomFuc" :loading="loading">
                        <el-option v-for="(item, index) in customData" :key="index"
                            :label="`${item.name}(${item.country})`" :value="item.id">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="addOrderFuc">生成订单</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fpVisible = false;">取消生成</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<script>
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import MyForm from '@/components/MyForm';
import MyUpload from '@/components/MyUpload';
import MyFormItem from '@/components/MyForm/MyFormItem';
// 引入随机字符串库
import { v4 as uuid } from 'uuid';
import { deleteUsers, repassUsers, listRole, userRole, listProducts, addProduct, deleteProducts, updateProduct, addTese, deleteTese, addCanshu, deleteCanshu, addCart2, deleteCart2, listCart2, addOrder, queryCustomer, clearCart2 } from '@/api';
import { formatTimeAgo, initTime, jumpTo, saveData } from '@/utils/myutils';
export default {
    data() {
        return {
            customData: [],
            loading: false,
            khVisible: false,
            nowKh: null,
            shopDrawer: false,
            cartDirection: 'btt',
            cartSize: '50%',
            cartData: [],
            inputTagValue2: '',
            teseVisible: false,
            shuxingVisible: false,
            updateVisible: false,
            nowVideo: [],
            inputTagVisible: false,
            inputTagValue: '',
            nowImg: [],
            nowImg2: [],
            isCheckAll: true,
            editState: false,
            refreshKey: 0,
            typeOptions: [
                {
                    value: 1,
                    label: '电子画册'
                },
                {
                    value: 2,
                    label: '在线设计'
                }
            ],
            nowSize: null,
            sizeOptions: [
                {
                    name: '画册推荐',
                    width: 900,
                    height: 1200
                },
                {
                    name: 'A4竖版',
                    width: 595,
                    height: 842
                },
                {
                    name: 'A4横版',
                    width: 842,
                    height: 595
                },
                {
                    name: '小红书配图',
                    width: 1242,
                    height: 1660
                },
                {
                    name: '公众号首图',
                    width: 900,
                    height: 383
                },
                {
                    name: '公众号次图',
                    width: 500,
                    height: 500
                },
                {
                    name: '竖版直播背景',
                    width: 1242,
                    height: 1660
                },
                {
                    name: '竖版视频封面',
                    width: 1242,
                    height: 2208
                },
                {
                    name: '横版视频封面',
                    width: 1920,
                    height: 1080
                },
                {
                    name: '商品主图',
                    width: 800,
                    height: 800
                },
                {
                    name: '电商详情页面',
                    width: 750,
                    height: 1000
                }
            ],
            sortOptions: [
                {
                    value: 0,
                    label: '默认排序'
                },
                {
                    value: 1,
                    label: '按创建时间降序'
                }
            ],
            addForm: {
                type: 0,
                name: '',
                detail: '',
                himg: '',
                img: '',
                state: 0,
                tag: '',
                tags: [],
                video: ''
            },
            updateForm: {
                id: null,
                type: 0,
                name: '',
                detail: '',
                himg: '',
                img: '',
                state: 0,
                tag: '',
                tags: [],
                video: ''
            },
            nowId: null,
            nowRole: [],
            roleDialog: false,
            registerDialog: false,
            registerDialog2: false,
            addVisible: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 15,
            searchSize: 15,
            maxSize: 0,
            searchMax: 0,
            nowType: null,
            nowSort: null,
            updateType: [],
            teseTags: [],
            shuxingTags: [],
            teseForm: {
                pid: null,
                txt: ''
            },
            shuxingForm: {
                pid: null,
                name: '',
                content: ''
            },
            nowSid: null
        }
    },
    components: {
        MyButton,
        MyDialog,
        MyForm,
        MyFormItem,
        MyUpload
    },
    mounted() {
        this.nowSid = this.$route.query.id || null;
        window.ceshiProduct && (this.customData = [...this.customData, window.ceshiProduct]);
        this.listProductsFuc();
        this.listCartFuc();
        this.cartDirection = this.isMobileByScreen() ? 'btt' : 'rtl';
        this.cartSize = this.isMobileByScreen() ? 'calc(100% - 60px)' : '450px';
    },
    methods: {
        jumpToProduct() {
            jumpTo(this, "商品项目管理", {}, { ctl: 'ad' });
        },
        async clearCart2Fuc() {
            const loading = this.$loading({
                lock: true,
                text: '清空购物车中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await clearCart2();
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '清空购物车成功',
                    type: 'success'
                });
                this.listCartFuc();
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
        },
        async queryCustomFuc(query) {
            if (query === '') {
                this.customData = [];
                return;
            }

            this.loading = true;

            const data = await queryCustomer({
                key: query
            });

            this.loading = false;

            if (data.code == 200) {

                this.customData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async addOrderFuc() {
            const loading = this.$loading({
                lock: true,
                text: '生成订单中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addOrder({
                sid: this.nowSid
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '清空购物车成功',
                    type: 'success'
                });
                jumpTo(this, "产品订单管理", {}, {});
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
        },
        handleChange(value) {

        },
        async addCartFuc(item, count) {
            const loading = this.$loading({
                lock: true,
                text: '加入购物车中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await addCart2({
                id: item.id,
                count: count
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '加入购物车成功',
                    type: 'success'
                });
                this.listCartFuc();
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
        },
        async listCartFuc() {
            const loading = this.$loading({
                lock: true,
                text: '刷新购物车中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await listCart2();
            loading.close();
            if (data.code == 200) {
                this.cartData = data.data || [];
                this.cartData.forEach(item => {
                    item.count2 = item.count || 0;
                })
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
        },
        isMobileByScreen() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
            const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            return isSmallScreen && isTouchDevice;
        },
        handleBtnClick(item, item3) {
            if (item3 == '编辑') {
                this.updateVisible = true;
                this.typeOptions.forEach(item4 => {
                    item4.data.forEach(item5 => {
                        if (item5.id == item.type) {
                            this.updateType = [item4.id, item5.id];
                        }
                    })
                });
                this.nowVideo = item.video == '' ? [] : [{
                    himg: `https://cdn.bosscaigou.com/${item.himg}`,
                    video: item.video
                }];
                this.nowImg = [item.himg];
                this.nowImg2 = item.img.split(',');
                this.updateForm = { ...item };
                this.updateForm.tags = item.tag.split(',').map(item => ({ tag: item }));
                this.roleDialog = true;
            } else if (item3 == '删除') {
                this.deleteProductsFuc([item.id]);
            } else if (item3 == '特点管理') {
                this.teseVisible = true;
                this.teseTags = item.tese || [];
                this.teseForm.pid = item.id;
                console.log(this.teseForm, item.id);
            } else if (item3 == '参数管理') {
                this.shuxingVisible = true;
                this.shuxingTags = item.canshu || [];
                this.shuxingForm.pid = item.id;
            }
        },
        showInput() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagClose(tag) {
            this.addForm.tags = this.addForm.tags.filter(item => item.tag != tag.tag);
            this.refreshKey++;
        },
        handleInputConfirm() {
            let inputTagValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputTagValue) {
                this.addForm.tags.push({
                    tag: inputTagValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput2() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagClose2(tag) {
            this.updateForm.tags = this.updateForm.tags.filter(item => item.tag != tag.tag);
            this.refreshKey++;
        },
        handleInputConfirm2() {
            let inputTagValue = this.inputTagValue;
            this.updateForm.tags = this.updateForm.tags == null ? [] : this.updateForm.tags;
            if (inputTagValue) {
                this.updateForm.tags.push({
                    tag: inputTagValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput3() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        async handleTagClose3(tag) {
            const loading = this.$loading({
                lock: true,
                text: '删除中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await deleteTese({ ids: [tag.id] });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.teseTags = this.teseTags.filter(item => item.id != tag.id);
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
            this.refreshKey++;
        },
        async handleInputConfirm3() {
            let inputTagValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputTagValue) {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.teseForm.txt = inputTagValue;
                const data = await addTese(this.teseForm);
                loading.close();
                if (data.code == 200) {
                    this.$message({
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.inputTagValue = '';
                    this.teseTags.push(data.data);
                } else {
                    this.$message({
                        message: data.message,
                        type: 'error'
                    });
                }
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput4() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        async handleTagClose4(tag) {
            const loading = this.$loading({
                lock: true,
                text: '删除中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await deleteCanshu({ ids: [tag.id] });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.shuxingTags = this.shuxingTags.filter(item => item.id != tag.id);
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
            this.refreshKey++;
        },
        async handleInputConfirm4() {
            let inputTagValue = this.inputTagValue;
            let inputTagValue2 = this.inputTagValue2;
            if (inputTagValue && inputTagValue2) {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.shuxingForm.name = inputTagValue;
                this.shuxingForm.content = inputTagValue2;
                const data = await addCanshu(this.shuxingForm);
                loading.close();
                if (data.code == 200) {
                    this.$message({
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.shuxingTags.push(data.data);
                    this.inputTagValue = '';
                    this.inputTagValue2 = '';
                } else {
                    this.$message({
                        message: data.message,
                        type: 'error'
                    });
                }
            }
            console.log(111222);
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        checkAll() {
            var state = false;
            this.isCheckAll = !this.isCheckAll;
            if (this.isCheckAll) {
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.searchData.forEach(item => {
                    item.checked = false;
                });
            } else {
                this.tableData.forEach(item => {
                    item.checked = true;
                });
                this.searchData.forEach(item => {
                    item.checked = true;
                });
            }
            this.refreshKey++;
        },
        handleItemClick(item) {
            if (this.editState) {
                console.log(item);
                item.checked = !item.checked;
                this.refreshKey++;
            } else {
                this.openProject(item);
            }
        },
        handleCheckClick() {
            this.editState = !this.editState;
            if (this.editState) {

            } else {
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.searchData.forEach(item => {
                    item.checked = false;
                });
            }
            this.refreshKey++;
        },
        // 删除产品
        async deleteProductsFuc(t) {

            if (t == null) {

                t = [];

                (this.searchTxt ? this.searchData : this.tableData).forEach(item => {

                    item.checked && (t[t.length] = item.id);

                });

                if (t.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

            }

            const loading = this.$loading({
                lock: true,
                text: '正在删除产品...',
                spinner: 'el-icon-loading',
            });

            const data = await deleteProducts({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message.success('删除成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }
        },
        // 添加产品
        async addProductFuc() {

            if (this.addForm.name == '') {
                this.$message.error('产品名称不能为空');
                return;
            }

            if (this.addForm.type == '' || this.addForm.type == null) {
                this.$message.error('产品类型不能为空!');
                return;
            }

            if (this.nowImg.length == 0) {
                this.$message.error('请上传产品封面');
                return;
            }

            this.addForm.himg = this.nowImg[0];

            if (this.nowImg2.length == 0) {
                this.$message.error('请上传产品图片');
                return;
            }

            this.addForm.img = this.nowImg2.join(',');

            this.addForm.tag = (this.addForm.tags || []).map(item => item.tag).join(',');

            this.addForm.video = (this.nowVideo || []).map(item => item.video).join(',');

            const loading = this.$loading({
                lock: true,
                text: '正在添加产品...',
                spinner: 'el-icon-loading',
            });

            const data = await addProduct(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message.success('添加成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }

            this.addVisible = false;

        },
        // 添加产品
        async updateProductFuc() {

            if (this.updateForm.name == '') {
                this.$message.error('产品名称不能为空');
                return;
            }

            if (this.updateForm.type == '' || this.updateForm.type == null) {
                this.$message.error('产品类型不能为空!');
                return;
            }

            if (this.nowImg.length == 0) {
                this.$message.error('请上传产品封面');
                return;
            }

            this.updateForm.himg = this.nowImg[0];

            if (this.nowImg2.length == 0) {
                this.$message.error('请上传产品图片');
                return;
            }

            this.updateForm.img = this.nowImg2.join(',');

            this.updateForm.tag = (this.updateForm.tags || []).map(item => item.tag).join(',');

            this.updateForm.video = (this.nowVideo || []).map(item => item.video).join(',');

            const loading = this.$loading({
                lock: true,
                text: '正在修改产品...',
                spinner: 'el-icon-loading',
            });

            const data = await updateProduct(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message.success('编辑成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }

            this.addVisible = false;

        },
        openProject(item) {
            saveData('projectId', item.pid);
            jumpTo(this, '页面', {}, {});
        },
        async listProductsFuc() {

            const loading = this.$loading({
                lock: true,
                text: '查询中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listProducts({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.nowType || -1,
                sort: this.nowSort || 0
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.typeOptions = data.type;

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initTime(date) {
            return initTime(date);
        },
        async userRoleFuc() {
            if (this.nowId == null || this.nowId == '') {
                this.$message.error('请先选择要修改的用户！');
                return;
            }
            if (this.nowRole.length == 0) {
                this.$message.error('请选择用户角色！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await userRole({
                id: this.nowId,
                role: this.nowRole[this.nowRole.length - 1]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        handleMaterialTypeChange(item) {
            this.addForm.type = item.length == 0 ? 0 : item[item.length - 1];
        },
        handleMaterialTypeChange2(item) {
            this.nowType = item.length == 0 ? 0 : item[item.length - 1];
            this.listProductsFuc();
        },
        handleMaterialTypeChange3(item) {
            this.updateForm.type = item.length == 0 ? 0 : item[item.length - 1];
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listProductsFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listProductsFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addUserCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchUsers() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listProductsFuc();

        },
        async repassUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        memberFilter(v, r, c) {

            return r.member === v;

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listProductsFuc();
        },
        handleSizeChange2(value) {
            const item = this.sizeOptions[value];
            this.addForm.width = item.width;
            this.addForm.height = item.height;
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listProductsFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        handleSearchChange() {
            this.searchPage = 1;
            this.searchData = [];
            this.nowSearchTxt = this.searchTxt;
            this.listProductsFuc();
        }
    }
}
</script>

<style>
.com-codics-book-admin-project-body {
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-book-admin-project-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-book-admin-project-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-book-admin-project-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-book-admin-project-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-book-admin-project-list {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-book-admin-project-list-item {
    height: 220px;
    width: 20%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;
}

.com-codics-book-admin-project-list-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: #FFF;
    border-radius: 6px;
    /* border: 1px solid #E5E5E5; */
    transition: .3s;
}

.com-codics-book-admin-project-list-item-card-img {
    height: calc(100% - 40px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 0 0 6px 6px;
    border-bottom: 1px solid #E5E5E5;
    overflow: hidden;
    box-sizing: border-box;
}

.com-codics-book-admin-project-list-item-card-img img {
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-bottom {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px;
    color: #333;
}

.com-codics-book-admin-project-list-item-card-bottom-img {
    height: 100%;
    width: 40px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 9px !important;
}

.com-codics-book-admin-project-list-item-card-bottom-img img {
    border-radius: 50%;
    overflow: hidden;
}

.com-codics-book-admin-project-list-item-card-bottom-txt {
    position: relative;
    float: left;
    width: fit-content;
    max-width: calc(50% - 40px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding-right: 10px;
}

.com-codics-book-admin-project-list-item-card-bottom-time {
    float: right !important;
    color: #999;
}

.com-codics-book-admin-project-list-item-card-bottom-btn {
    height: 100%;
    width: 40px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    user-select: none;
    text-align: center;
    transition: .3s;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-add {
    height: 30px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 40px;
    left: 0;
    box-sizing: border-box;
    background: #333;
    border-radius: 4px;
    color: #FFF;
    cursor: pointer;
    user-select: none;
    text-align: center;
    line-height: 30px;
    font-size: 10px;
    opacity: 0;
    transition: .3s;
    padding: 0 15px;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card:hover .com-codics-book-admin-project-list-item-card-add {
    opacity: .7;
}

.com-codics-book-admin-project-list-item-card-add:hover {
    opacity: 1 !important;
}

.com-codics-book-admin-project-list-item-card-add:active {
    opacity: .9 !important;
}

@media screen and (max-width: 1400px) {
    .com-codics-book-admin-project-list-item {
        width: 33.33333%;
    }
}

@media screen and (max-width: 756px) {
    .com-codics-book-admin-project-list-item {
        width: 50%;
    }
}

@media screen and (max-width: 556px) {
    .com-codics-book-admin-project-list-item {
        width: 100%;
    }
}

.com-codics-book-admin-project-list-tip {
    height: 40px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 180px;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    font-size: 13px;
    color: #999;
    text-align: center;
    line-height: 40px;
    opacity: var(--opacity);
    transition: .3s;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-bottom-btn-popover {
    padding: unset !important;
    border-radius: 5px !important;
}

.com-codics-book-admin-project-list-item-card-bottom-btn-item {
    height: 33px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    user-select: none;
    text-align: center;
    transition: .3s;
    -webkit-user-drag: none;
    font-family: 'pingfang-regular';
}

.com-codics-book-admin-project-list-item-card-bottom-btn-item:hover {
    background: #EEE;
}

.input-new-tag {
    width: 90px !important;
    margin-right: 10px;
    vertical-align: bottom;
}
</style>